import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface AccountLedgerState {
  data: any[];
  totalRecords: number;
  totalPages: number;
  currentPage: number;
}

const initialState: AccountLedgerState = {
  data: [],
  totalRecords: 0,
  totalPages: 0,
  currentPage: 0,
};

export const accountLedgerSlice = createSlice({
  name: "accountLedger",
  initialState,
  reducers: {
    setAccountLedger: (state, action: PayloadAction<any>) => {
      state.data = action.payload.data || [];
      state.totalRecords = action.payload.totalRecords || 0;
      state.totalPages = action.payload.totalPage || 0;
      state.currentPage = action.payload.currentPage || 0;
    },
    resetAccountLedger: () => initialState,
  },
});

export const { setAccountLedger, resetAccountLedger } = accountLedgerSlice.actions;

export const getAccountLedgerData = (state: RootState) => state.accountLedger.data;
export const getAccountLedgerTotalRecords = (state: RootState) => state.accountLedger.totalRecords;
export const getAccountLedgerTotalPages = (state: RootState) => state.accountLedger.totalPages;
export const getAccountLedgerCurrentPage = (state: RootState) => state.accountLedger.currentPage;

export default accountLedgerSlice.reducer;
